import React from "react";
import './comp16.css'

class Comp16 extends React.Component {
  render() {
    return (
      <div id="blog" className="comp16" data-part-id="container" size={2} >
        <h3 className="comp16_1" data-part-id="text" size={4}>
          Blog
        </h3>
        <p className="comp16_2" data-part-id="text" size={5}>
          More about what we're doing.
        </p>
      </div>
    );
  }
}

export default Comp16;
